module.exports = __webpack_public_path__ + "media/icons/gallery-prev@3x-604eb93a.svg";